import React from "react";
import PropTypes from "prop-types";

const TextArea = ({
  label,
  name,
  placeholder,
  error,
  onChange,
  value,
  className,
}) => {
  const containerClassName = `input-group ${className || ""}`;
  const inputClassName = `w-full popInput ${error ? "borderRed" : ""}`;

  return (
    <div className={containerClassName}>
      {label && <label htmlFor={name}>{label}</label>}
      <textarea
        cols="30"
        rows="5"
        placeholder={placeholder}
        name={name}
        className={inputClassName}
        onChange={onChange}
        value={value}
      ></textarea>

      {error && <p className="error">{error.message}</p>}
    </div>
  );
};

TextArea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default TextArea;
